import { handleActions } from "redux-actions";
import initialState from "../../config/initialState";
import {
  GET_MANAGEMENT_SUCCESS,
  GET_MANAGEMENT_FAIL,
  GET_MANAGEMENT_DURATION_SUCCESS,
  GET_MANAGEMENT_DURATION_FAIL
} from "../actions/riskAnalysis";

export default handleActions(
  {
    [GET_MANAGEMENT_SUCCESS]: (state, action) => {
      const payload = action.payload || {};
      const isMapFormat = payload && !Array.isArray(payload) && ('matrix' in payload || 'assets' in payload || 'instruments' in payload);
      
      let matrix = isMapFormat ? (payload.matrix || {}) : (payload || {});
      if (Array.isArray(matrix)) {
        const matrixMap = {};
        matrix.forEach(item => {
          if (item && item.asset) {
            matrixMap[item.asset] = item.instruments || [];
          }
        });
        matrix = matrixMap;
      }

      return {
        ...state,
        items: matrix,
        assets: isMapFormat ? (payload.assets || {}) : {},
        instruments: isMapFormat ? (payload.instruments || {}) : {}
      };
    },
    [GET_MANAGEMENT_FAIL]: () => initialState.riskAnalysis,

    [GET_MANAGEMENT_DURATION_SUCCESS]: (state, action) => {
      return {
        ...state,
        durations: action.payload
      }
    },
    [GET_MANAGEMENT_DURATION_FAIL]: () => initialState.riskAnalysis
  },
  initialState.riskAnalysis
);
